export default __webpack_public_path__ + "static/media/melissasm.0c175696.jpg";